import { Component, inject } from '@angular/core';
import { Page } from '../../page/page';
import { SurveyRenderControllerStore } from '../../render-store/render.store';
import { UnifiedSurveyStore } from '../../render-store/unified-survey.store';
import { InteractionTypes } from '@hyper-inferno/survey-elements-core-utils';

@Component({
  selector: 'lib-survey-page',
  imports: [Page],
  templateUrl: './survey-page.html',
  styleUrl: './survey-page.css',
})
export class SurveyPage {
  onPageAction($event: { type: InteractionTypes; payload?: any }) {
    switch ($event.type) {
      case InteractionTypes.SUBMIT:
        return this.onSubmit();
      case InteractionTypes.SWITCH:
        return this.surveyBotController.onSwitchQuestionClick(
          $event.payload ?? false,
        );
      // case InteractionTypes.LOGIN:
      //   return this.onLoginClick(event.payload);
      default:
        break;
    }
  }
  surveyRenderStore = inject(SurveyRenderControllerStore);
  surveyBotController = inject(UnifiedSurveyStore);

  onSubmit() {
    this.surveyRenderStore.attemptSubmit();
    const pageElements =
      this.surveyRenderStore.currentPageState?.().page?.elements ?? [];
    const registry = this.surveyRenderStore.registry();

    const currentIds = pageElements.map((el) => String(el.id));

    let pageValid = true;

    currentIds.forEach((id) => {
      const entry = registry[id];
      if (entry && typeof entry.validate === 'function') {
        // We trigger the child's logic REMOTELY
        const isElementValid = entry.validate();
        if (!isElementValid) pageValid = false;
      }
    });
    if (pageValid) {
      this.surveyBotController.onSubmitButtonClick();
    }
  }
}
